import { useMemo } from 'react'
import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'
import { Equipment } from '@types'

import { getEquipment } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los vehículos',
  })
}

const useEquipment = () => {
  const { data, isLoading } = useQuery<Equipment[]>([QUERY_KEYS.CARRIER_EQUIPMENT], getEquipment, {
    staleTime: Infinity,
    onError,
  })

  const equipmentOptions = useMemo(
    () =>
      data
        ?.map(equipment => ({
          label: equipment.nameShort,
          value: equipment.id,
          straightTruck: equipment.straightTruck,
        }))
        .sort((a, b) => (a.label.toUpperCase() < b.label.toUpperCase() ? -1 : 1)),
    [data],
  )

  const hasTrailertOptions = useMemo(
    () =>
      data?.map(equipment => ({
        label: equipment.straightTruck,
        value: equipment.id,
      })),
    [data],
  )

  return {
    equipments: data,
    isLoading,
    equipmentOptions,
    hasTrailertOptions,
  }
}

export { useEquipment }
